import type { Category } from '../types'

/**
 * Kategori renkleri (kullanıcı, 22 Eki 2026): her kategori kendi renginde,
 * ürünleri o rengin açık tonunda; garson ve kasa ürünü renginden buluyor.
 * Patron Menü ekranında bu 12 renkten seçiyor. Serbest renk seçici yok:
 * her renk hem açık hem koyu modda okunaklı kalacak şekilde seçildi.
 */
export const CATEGORY_COLORS = [
  { id: 'turuncu', name: 'Turuncu', hex: '#f76b15' },
  { id: 'mavi', name: 'Mavi', hex: '#2a78d6' },
  { id: 'yesil', name: 'Yeşil', hex: '#22a06b' },
  { id: 'mor', name: 'Mor', hex: '#7c5cd6' },
  { id: 'turkuaz', name: 'Turkuaz', hex: '#0d9488' },
  { id: 'sari', name: 'Sarı', hex: '#e0a100' },
  { id: 'pembe', name: 'Pembe', hex: '#d6409f' },
  { id: 'lacivert', name: 'Lacivert', hex: '#4f46e5' },
  { id: 'fistik', name: 'Fıstık', hex: '#65a30d' },
  { id: 'gok', name: 'Gök', hex: '#0891b2' },
  { id: 'kahve', name: 'Kahve', hex: '#9a6b3f' },
  // En sonda: "Bitti" ürünlerin kırmızısıyla karışmasın, otomatik gelmesin.
  { id: 'kirmizi', name: 'Kırmızı', hex: '#e5484d' },
] as const

export type CategoryColorId = (typeof CATEGORY_COLORS)[number]['id']

const byId = new Map<string, (typeof CATEGORY_COLORS)[number]>(CATEGORY_COLORS.map((c) => [c.id, c]))

/**
 * Kategorinin rengi. Patron seçmediyse varsayılan: kategorinin menüdeki
 * sırasına göre paletten, yan yana kategoriler farklı renkte.
 */
export function categoryColor(category: Pick<Category, 'id' | 'color'>, categories: Pick<Category, 'id'>[]) {
  const chosen = category.color ? byId.get(category.color) : undefined
  if (chosen) return chosen
  const i = Math.max(0, categories.findIndex((c) => c.id === category.id))
  return CATEGORY_COLORS[i % CATEGORY_COLORS.length]
}
